/*
 * @Descripttion: 
 * @version: v0.0.1
 * @Author: ZhouYanPing
 * @Date: 2021-06-04 13:40:37
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-30 16:49:57
 */

import React, {useEffect, useState} from "react";
import Reflux from 'reflux';
import {config, request} from 'Utils';
import {Row, Col, Icon, Modal, Input, Button, message, DatePicker} from 'antd';
import {hashHistory, withRouter, Link,} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew, MyUpload, AntDraggableModal} from 'Components';
import {
    rebateBillList,
    rebateBillImport,
    rebateBillBack,
    rebateBillSend,
    rebateBillConfirmOrReject,
    rebateBillUpload,
    getDiscountType,
    getRebateBillDetail,
    rebateBillSendAll,
    rebateBillSendEsign,
    rebateBillViewEsign
} from '../../service/rebateBillManage';
import {customerList} from '../../service/shoppingCar';
import {sKeylist} from '../../service/dictionary/dataitem';
import {getProductCategory} from '../../service/product';
import {showSpin, hideSpin,} from 'Utils';
import {Store, Actions,} from './store';
import './rebateBillManage.css';

import {Document as PDFDocument, Page as PDFPage, setOptions} from 'react-pdf/dist/entry.webpack';

setOptions({
    cMapUrl: 'cmaps/',
    cMapPacked: true,
});

const confirm = Modal.confirm;
const RangePicker = DatePicker.RangePicker;
const url = config.index == 1 ? 'https://sign.tengen.com' : 'https://sign03.tengen.com:8443';

class InfoList extends Reflux.Component {
    constructor(props) {
        super(props);
        const currentChannel = window.sessionStorage.getItem('cur_channel') || '';
        this.channelCode = currentChannel.split('|')[1] || '';
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            pdfFile: '',
            numPages: null,
            deg: 0,
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}'),
            confirmRejectVisible: false, // 财务确认/驳回
            fileUpDownloadVisible: false, // 扫描件下载、上传
            operatingBtn: '',    // 操作按钮
            fileList: [],
            selectData: {},
            printBillConfirmVisible: false, // 打印
            oneImportVisible: false, // 一键导入
            visitLoading: false, // 导入
            importParams: {
                dateValue: [],
                dateFrom: '', // 开始时间yyyy-MM-dd
                dateTo: '', // 结束时间yyyy-MM-dd
                fbillno: '', // 流程编号
                custName: '', //客户名称
                salesUnit: '', //购货单位
                confirmPeople: ''//审批者
            },

            lookFileVisible: false,
            rebateBillDetailVisible: false,
            rebateBillDetail: [],
            billDetailTitle: [],
            billDetailData: [],
            confirmRejectVal: '',
            button_limits_end: {}, // 按钮权限控制

            groupOptions: [], // 商品分组
            discountTypes: [], // 商品系列
            productCategoryTree: [], // 商品分类
            filterBoxVisible: false,
            customerList: [],
            selectedRowKeys: [],
            selectedRows: [],
            statusList: [
                {value: 0, text: '待处理'},
                {value: 1, text: '未上传'},
                {value: 2, text: '已上传'},
                {value: 3, text: '已审批'},
                {value: 4, text: '已驳回'},
                {value: 5, text: '发起中'},
                {value: 6, text: '签署中'},
                {value: 7, text: '撤回中'},
            ],
            eSingStatusList: [
                {value: 'DRAFT', text: '草稿'},
                {value: 'FILLING', text: '拟定中'},
                {value: 'SIGNING', text: '签署中'},
                {value: 'COMPLETE', text: '已完成'},
                {value: 'REJECTED', text: '已拒签'},
                {value: 'RECALLED', text: '已撤回'},
                {value: 'EXPIRED', text: '已过期'},
                {value: 'TERMINATING', text: '作废中'},
                {value: 'TERMINATED', text: '已作废'},
                {value: 'DELETE', text: '已删除'},
                {value: 'FINISHED', text: '强制完成'},
                {value: 'ERROR', text: '异常'},
            ],
            rows: [],
            total: 0,
            searchObj: {
                pianqu: '',  // 片区
                salesChannel: '',  // 渠道
                customerNumber: '',  // 客户编号
                customerName: '',  // 客户名称
                salesUnitName: '',  // 单位名称
                calculation: '',  // 计提单号
                confirmPeople: '',  // 确认人
                creationDateStart: '',  // 结算时间 yyyy-MM-dd
                creationDateEnd: '',  // 结算时间 yyyy-MM-dd
                // dataValue: [],
                discountType: '',  // 折扣类型
                status: [],  // 状态0:待处理,1:未上传,2:已上传,3:财务已确认,4:财务已驳回
                p: 1,  // 页码
                s: 10,  // 页容
            },
            extensions: ['png', 'jpg', 'pdf', 'jpeg', 'bmp', 'tif', 'gif'] // 在线查看附件类型扩展
        };
        this.getData = this.getData.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    // 打开PDF文件
    onFileChange = (event) => {
        this.setState({
            pdfFile: event.target.files[0],
        });
    }

    // pdf加载成功
    onDocumentLoadSuccess(data) {
        console.log(data);
        this.setState({
            numPages: data.numPages,
        })
    }

    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname;
        if (/^\/merchandise\/add\/\d+$/.test(path)) { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange({...this.state.searchObj});
            window.sessionStorage.removeItem('mechandise-form-data-cache')
        } else {
            Actions.useStoreChange(false);
        }
    }

    componentWillMount() { //准备数据
        const that = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params,
                },
            });
        }
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    componentDidMount() {
        // 查询列表
        this.getData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        // 获取所有折扣明细类
        this.getDiscountTypes();
    }

    // 获取所有折扣明细类
    getDiscountTypes() {
        let that = this;
        getDiscountType().then(res => {
            if (res.status) {
                let list = [{value: '', text: '全部'}];
                list = list.concat(res.data.map((x) => {
                    return {value: x, text: x}
                }))
                that.setState({discountTypes: list});
            }
        });
    }

    // 列表查询
    getData() {
        const that = this;
        const {searchObj} = this.state;
        rebateBillList(searchObj).then(res => {
            if (res.status) {
                that.setState({total: res.total, rows: res.data});
            } else {
                console.error(res.message);
            }
        });
    }

    // 操作按钮
    operating(type, data) {
        console.log(type, data)
        let that = this;
        this.setState({operatingBtn: type, selectData: data})
        switch (type) {
            // 打印
            case 'print':
                this.setState({printBillConfirmVisible: true})
                break;
            // 查看
            case 'look':
                getRebateBillDetail({
                    calculation: data.calculation,
                    salesChannel: data.salesChannel,
                    year: data.year
                }).then(res => {
                    if (res && res.status) {
                        let keys = res.data.title;
                        let data = res.data.value;
                        res.data.value.map((item) => {
                            // let val = []
                            // let str = JSON.stringify(item);
                            // console.log(str)

                            // // 同顺序转数组
                            // let objArr = str.substr(1, str.length - 2).replace(/\"/g, '').split(",");
                            // objArr.map((o) => {
                            //     let attr = o.split(":");
                            //     if (!keys.includes(attr[0])) {
                            //         keys.push(attr[0]);
                            //     }
                            //     val.push(attr[1] == 'null' ? '' : attr[1]);
                            // })

                            // let val = {};
                            // keys.map((key) => {
                            //     val[key] = item[key];
                            // })
                            // data.push(val);
                        })
                        console.log(keys, data)

                        that.setState({
                            rebateBillDetailVisible: true,
                            rebateBillDetail: res.data,
                            billDetailTitle: keys,
                            billDetailData: data,
                        });
                    } else {
                        message.error('查看详情失败')
                    }
                });
                break;
            // 上传扫描件
            case 'upload':
                this.setState({
                    fileUpDownloadVisible: true,
                    fileList: []
                });
                break;
            // 扫描件下载
            case 'download':
                this.setState({
                    fileUpDownloadVisible: true,
                    fileList: []
                });
                break;
            // 扫描件查看
            case 'lookFile':
                // 图片或PDF可查看
                if (this.state.extensions.includes(data.extension)) {
                    let file = config.server + data.url
                    this.setState({
                        lookFileVisible: true,
                        pdfFile: file,
                    });
                } else {
                    message.warning('只有图片或PDF文件可在线查看，请自行下载查看')
                }
                break;
            //查看电子签
            case 'lookEsign':
                rebateBillViewEsign({id: data.id}).then(res => {
                    if (res.status) {
                        window.open(res.data);
                    }
                });
                break;
            //下载电子签
            case 'downLoadEsign':
                window.open(`${config.server}/api/v1/dms/settle/order/downLoadEsign/${data.id}`);
                break;
            // 发送
            case 'send':
                confirm({
                    title: '系统提示',
                    content: '是否确认发送',
                    onOk() {
                        rebateBillSend({id: data.id}).then(res => {
                            if (res.status) {
                                that.getData();
                            }
                        });
                    },
                    onCancel() {
                    },
                });
                break;
            case 'sendEsign':
                confirm({
                    title: '系统提示',
                    content: '是否确认发送',
                    onOk() {
                        rebateBillSendEsign({id: data.id}).then(res => {
                            if (res.status) {
                                that.getData();
                            }
                        });
                    },
                    onCancel() {
                    },
                });
                break;
            // 撤回
            case 'back':
                confirm({
                    title: '系统提示',
                    content: '是否确认撤回',
                    onOk() {
                        rebateBillBack({id: data.id}).then(res => {
                            if (res.status) {
                                that.getData();
                            }
                        });
                    },
                    onCancel() {
                    },
                });
                break;
            // 确认
            case 'confirm':
                this.setState({
                    confirmRejectVisible: true,
                    confirmRejectVal: ''
                });
                break;
            // 驳回
            case 'turnDown':
                this.setState({
                    confirmRejectVisible: true,
                    confirmRejectVal: ''
                });
                break;
        }
    }

    // 重置
    advanceReset() {
        const that = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                pianqu: '',  // 片区
                salesChannel: '',  // 渠道
                customerNumber: '',  // 客户编号
                customerName: '',  // 客户名称
                salesUnitName: '',  // 单位名称
                calculation: '',  // 计提单号
                confirmPeople: '',  // 确认人
                creationDateStart: '',  // 结算时间 yyyy-MM-dd
                creationDateEnd: '',  // 结算时间 yyyy-MM-dd
                // dataValue: [],
                discountType: '',  // 折扣类型
                status: [],  // 状态0:待处理,1:未上传,2:已上传,3:财务已确认,4:财务已驳回
                p: 1,
            },
        }, function () {
            that.getData();
        });
    };

    // 查询
    advanceSubmit() {
        const that = this;
        this.setState({filterBoxVisible: false, searchObj: {...this.state.searchObj, p: 1}}, function () {
            that.getData();
        });
    };

    // 设置 查询字段
    setFilterParam(name, value) {
        if (name === 'creationDate') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    creationDateStart: value.from,
                    creationDateEnd: value.end,
                },
            });
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}});
        }
    };

    // 分页
    pageChange(page, pageSize) {
        const that = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            that.getData();
        });
    }

    // 一键导入-确定
    oneImportOk() {
        let that = this;
        if (!this.state.importParams.dateFrom) {
            message.error('请选择确认日期');
            return;
        }
        this.setState({
            // visitLoading: true
            oneImportVisible: false,
        }, function () {
            let confirmTimeStart = this.state.importParams.dateFrom;
            let confirmTimeEnd = this.state.importParams.dateTo;
            let custName = this.state.importParams.custName;
            let salesUnit = this.state.importParams.salesUnit;
            let confirmPeople = this.state.importParams.confirmPeople;
            window.open(`${config.server}/api/v1/dms/settle/order/download?confirmTimeStart=${confirmTimeStart}&confirmTimeEnd=${confirmTimeEnd}&custName=${custName}&salesUnit=${salesUnit}&confirmPeople=${confirmPeople}`);
        })

        // let params = Object.assign({}, this.state.importParams)
        // delete params.dateValue;
        // rebateBillImport(this.state.importParams).then(res => {
        //     if (res.code == 200) {
        //         message.success("导入成功");
        //         that.setState({
        //             oneImportVisible: false,
        //             visitLoading: false
        //         });
        //         that.getData();
        //     } else {
        //         that.setState({
        //             visitLoading: false
        //         });
        //     }
        // });
    }

    // 弹窗-取消
    modalCancel(name) {
        this.state[name] = false;
        this.setState({
            ...this.state[name]
        });
    }

    // 查看详情-确定
    rebateBillDetailOk() {
        this.setState({
            rebateBillDetailVisible: false,
        });
    }

    // 查看详情-导出
    exportDetail() {
        let data = this.state.selectData;
        window.open(`${config.server}/api/v1/dms/settle/order/detail/export?calculation=${data.calculation}&salesChannel=${data.salesChannel}&year=${data.year}`);
    }

    // 财务确认/驳回-确定
    confirmRejectOk() {
        // if (!this.state.confirmRejectVal) {
        //     message.error('请填写意见');
        //     return;
        // }
        let that = this;
        let params = {
            id: this.state.selectData.id,  // 返利单id
            financialReturn: this.state.confirmRejectVal,  // 财务回复
            status: this.state.operatingBtn == 'confirm' ? 3 : 4,  // 3:财务已确认,4:财务已驳回
        }
        rebateBillConfirmOrReject(params).then(res => {
            if (res.status) {
                message.success('操作成功');
                that.setState({
                    confirmRejectVisible: false,
                }, function () {
                    that.getData();
                });
            }
        });
    }

    changeConfRejVal(e) {
        this.setState({
            confirmRejectVal: e.target.value
        })
    }

    // 打印预览-确定
    printBillConfirmOk() {
        let oldHtml = window.document.body.innerHTML;
        let printDom = document.querySelector(".print");
        window.document.body.innerHTML = "";
        window.document.body.appendChild(printDom);
        window.print();
        window.document.body.innerHTML = oldHtml;
        window.location.reload();

        // window.document.body.innerHTML = window.document.getElementById('printDiv').innerHTML;  
        // window.print(); 
        // window.location.reload();

        this.setState({
            printBillConfirmVisible: false,
        });
    }

    // 扫描下载-确定
    fileUpDownloadOk() {
        let that = this;
        if (this.state.operatingBtn == 'upload') {
            if (this.state.fileList.length == 0) {
                message.error('请先上传附件')
                return;
            }
            let file = this.state.fileList[0].response.data;
            let params = {
                id: this.state.selectData.id,  // 返利单id
                url: file.filePath,  // 统一上传后返回附件url
                fileId: file.id,  // 统一上传后返回Id
                extension: file.extension,  // 统一上传后返回Id
            }
            rebateBillUpload(params).then(res => {
                if (res.code == 200) {
                    message.success("上传成功");
                    that.setState({
                        fileUpDownloadVisible: false,
                    }, function () {
                        that.getData();
                    });
                }
            });
        } else {
            that.setState({
                fileUpDownloadVisible: false,
            });
            if (this.state.selectData.filePath != null) {
                window.open(`${config.server}/api/v1/dms/settle/order/download?id=${this.state.selectData.id}&secure=${this.state.selectData.filePath.substring(this.state.selectData.filePath.indexOf("&secure=") + 8)}`);
            }
        }
    }

    /**
     * 批量下载附件
     */
    batchDownload() {
        // const { selectedRowKeys, selectedRows } = this.state;
        // if (!selectedRowKeys.length) {
        //     message.warn('请选择需要下载返利单');
        //     return;
        // }
        // console.log(selectedRowKeys, selectedRows)
        // let fbillnos = [];
        // // 判断是否选择了未上传附件
        // for (let i = 0; i < selectedRows.length; i++) {
        //     if (!selectedRows[i].fileId) {
        //         fbillnos.push(selectedRows[i].fbillno)
        //     }
        // }
        // if (fbillnos.length > 0) {
        //     // message.warn(`当前返利单编号为：【${fbillnos.toString()}】的未上传扫描件`);
        //     Modal.error({
        //         title: '系统提示',
        //         okText: '确定',
        //         content: `当前返利单编号为：【${fbillnos.toString()}】的未上传扫描件`,
        //     });
        //     return;
        // }

        this.setState({
            oneImportVisible: true
        })
    }

    /**
     * 一键导入返利单
     */
    oneImport() {
        this.setState({
            oneImportVisible: true,
            importParams: {
                dateValue: [],
                dateFrom: '', // 开始时间yyyy-MM-dd
                dateTo: '', // 结束时间yyyy-MM-dd
                fbillno: '', // 流程编号
            }
        })
    }

    /**
     * 导出
     */
    exportData() {
        // 拼接参数
        let params = '';
        let searchObj = this.state.searchObj;
        let keys = Object.keys(searchObj)
        keys.map((key) => {
            if (key != 'p' && key != 's' && searchObj[key]) {
                if (params == '') params += '?';
                if (searchObj[key] == '' || searchObj[key] == []) {
                } else {
                    if (key == 'status') {
                        searchObj[key].map((item) => {
                            params += `${key}=${item}&`;
                        });
                    } else {
                        params += `${key}=${searchObj[key]}&`;
                    }
                }
            }
        })
        if (params) params = params.substr(0, params.length - 1);
        // console.log(searchObj, keys, params)
        window.open(`${config.server}/api/v1/dms/settle/order/export` + params);
    }

    /**
     * 一键发送
     */
    oneSendAll() {
        const {selectedRowKeys, selectedRows} = this.state;
        if (!selectedRowKeys.length) {
            message.warn('请选择需要发送的返利单');
            return;
        }
        console.log(selectedRowKeys, selectedRows)
        let ids = [];
        // 判断是否选择了未上传附件
        for (let i = 0; i < selectedRows.length; i++) {
            // 状态0:待处理,1:未上传,2:已上传,3:财务已确认,4:财务已驳回
            if (selectedRows[i].status === 0) {
                ids.push(selectedRows[i].id)
            }
        }
        if (ids.length === 0) {
            message.warn('没有可发送状态的返利单');
            return;
        }
        let that = this;
        rebateBillSendAll(ids.join()).then(res => {
            if (res.code == 200) {
                message.success("发送成功");
                that.getData();
            }
        });
    }

    // 导入时间
    onImportDateChange(value, dateString) {
        this.state.importParams.dateValue = value;
        this.state.importParams.dateFrom = dateString[0];
        this.state.importParams.dateTo = dateString[1];
        this.setState({
            importParams: {...this.state.importParams}
        })
    }

    onImportCustChange(event) {
        this.state.importParams.custName = event.target.value;
        this.setState({
            importParams: {...this.state.importParams}
        })
    }

    onImportUnitChange(event) {
        this.state.importParams.salesUnit = event.target.value;
        this.setState({
            importParams: {...this.state.importParams}
        })
    }

    onImportConfirmChange(event) {
        this.state.importParams.confirmPeople = event.target.value;
        this.setState({
            importParams: {...this.state.importParams}
        })
    }

    // 导入 流程编号
    onImportCodeChange(e) {
        this.state.importParams.fbillno = e.target.value;
        this.setState({
            importParams: {...this.state.importParams}
        })
    }

    // 附件上传
    uploadChange(list) {
        this.setState({fileList: list})
    }

    handleRote = () => {
        var deg = this.state.deg;
        deg += 90;
        this.setState({
            deg,
        })
        document.getElementById("preview-div").style.transform = "rotate(" + deg + "deg)";
        document.getElementById("preview-div").style.WebkitTransform = "rotate(" + deg + "deg)";
        document.getElementById("preview-div").style.MozTransform = "rotate(" + deg + "deg)";
        document.getElementById("preview-div").style.OTransform = "rotate(" + deg + "deg)";
        document.getElementById("preview-div").style.MsTransform = "rotate(" + deg + "deg)";
    }

    handleWheelImage = (e) => {
        const img = document.getElementById("preview-img");　//获取对应的dom
        const oWidth = img.style.width.replace('%', ''); //取得图片的实际宽度
        img.style.width = (Number(oWidth) + e.deltaY / 50) + '%'; //设置图片宽度
    }

    render() {
        const {
            rows, total, searchObj, statusList, selectedRowKeys, selectedRows,
            discountTypes, selectData, button_limits_end, fileList, extensions, eSingStatusList,
        } = this.state;

        // 判断用户类型，显示查询条件
        let fileds = [
            {
                name: 'pianqu',
                label: '片区',
                text: '请输入片区',
                type: 'default',
                defaultValue: searchObj.pianqu,
            }, {
                name: 'customerNumber',
                label: '客户编号',
                text: '请输入客户编号',
                type: 'default',
                defaultValue: searchObj.customerNumber
            }, {
                name: 'customerName',
                label: '客户名称',
                text: '输入客户名称',
                type: 'default',
                defaultValue: searchObj.customerName
            }, {
                name: 'salesUnitName',
                label: '购货单位',
                text: '请输入购货单位',
                type: 'default',
                defaultValue: searchObj.salesUnitName,
            }, {
                name: 'calculation',
                label: '单号',
                text: '请输入单号',
                type: 'default',
                defaultValue: searchObj.calculation
            }, {
                name: 'confirmPeople',
                label: '审批者',
                text: '请输入审批者',
                type: 'default',
                defaultValue: searchObj.confirmPeople
            }, {
                name: 'discountType',
                label: '折扣明细类',
                options: discountTypes,
                multiple: false,//支持多选
                type: 'select',
                defaultValue: searchObj.discountType,
            }, {
                name: 'status',
                label: '状态',
                options: statusList,
                multiple: true,//支持多选
                type: 'select',
                defaultValue: searchObj.status,
            }, {
                name: 'creationDate',
                label: '开始时间',
                options: [
                    {text: '开始时间'},
                    {text: '结束时间'},
                ],
                type: 'dateItem',
                defaultValue: {
                    from: searchObj.creationDateStart || '',
                    end: searchObj.creationDateEnd || ''
                },
            },
        ];
        if (!this.state.userData.ownEmp) {
            fileds = [
                {
                    name: 'salesUnitName',
                    label: '购货单位',
                    text: '请输入购货单位',
                    type: 'default',
                    defaultValue: searchObj.salesUnitName,
                }, {
                    name: 'calculation',
                    label: '单号',
                    text: '请输入单号',
                    type: 'default',
                    defaultValue: searchObj.calculation
                }, {
                    name: 'confirmPeople',
                    label: '确认人',
                    text: '请输入确认人',
                    type: 'default',
                    defaultValue: searchObj.confirmPeople
                }, {
                    name: 'discountType',
                    label: '折扣明细类',
                    options: discountTypes,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.discountType,
                }, {
                    name: 'status',
                    label: '状态',
                    options: statusList,
                    multiple: true,//支持多选
                    type: 'select',
                    defaultValue: searchObj.status,
                }, {
                    name: 'creationDate',
                    label: '开始时间',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateItem',
                    defaultValue: {
                        from: searchObj.creationDateStart || '',
                        end: searchObj.creationDateEnd || ''
                    },
                },
            ];
        }
        const advanceProps = {
            fileds: fileds,
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam,
        };
        const tableViewProps = {
            loading: false,
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange,
            },
            rowSelection: {
                selectedRowKeys: selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.setState({selectedRowKeys, selectedRows})
                },
            },
            columns: [
                {
                    title: '流程编号',
                    dataIndex: 'fbillno',
                }, {
                    title: '片区',
                    dataIndex: 'pianqu',
                }, {
                    title: '客户编号',
                    dataIndex: 'customerNumber',
                }, {
                    title: '客户名称',
                    dataIndex: 'customerName',
                }, {
                    title: '购货单位ID',
                    dataIndex: 'salesUnitId',
                }, {
                    title: '购货单位',
                    dataIndex: 'salesUnitName',
                }, {
                    title: '折扣明细类',
                    dataIndex: 'discountType',
                }, {
                    title: '金额(元)',
                    dataIndex: 'amount',
                    width: '100px',
                }, {
                    title: '归属年份',
                    dataIndex: 'year',
                }, {
                    title: '单号',
                    dataIndex: 'calculation',
                    width: '100px',
                },
                {
                    title: '单据编号',
                    dataIndex: 'transferNumber',
                }, {
                    title: '结算日期',
                    dataIndex: 'creationDate',
                    render: function (text, record, index) {
                        return record.creationDate;
                    }
                }, {
                    title: '状态',
                    dataIndex: 'status',
                    render: function (text, record, index) {
                        let status = statusList.filter((item) => {
                            return item.value === text
                        });
                        return status ? status[0].text : '-';
                    }
                },
                {
                    title: '电签状态',
                    dataIndex: 'eSignStatus',
                    render: function (text, record, index) {
                        if (text != null) {
                            let status = eSingStatusList.filter((item) => {
                                return item.value === text
                            });
                            return status ? status[0].text : '-';
                        }
                    }
                },
                {
                    title: '审批者',
                    dataIndex: 'confirmPeople',
                }, {
                    title: '审批时间',
                    dataIndex: 'confirmTime',
                }, {
                    title: '计算过程明细',
                    dataIndex: 'detail',
                    render: (text, record, index) => {
                        if (button_limits_end.rebateBill_look) {
                            return <a onClick={() => this.operating('look', record)}>查看</a>
                        }
                    },
                }, {
                    title: '打印结算单',
                    dataIndex: 'url',
                    render: (text, record, index) => {
                        // 状态0:待处理,1:未上传,2:已上传,3:财务已确认,4:财务已驳回 record.status !== 0 && record.status !== 1 &&
                        if (button_limits_end.rebateBill_print && record.signMethod == 0) {
                            return <a onClick={() => this.operating('print', record)}>打印</a>
                        }
                    },
                }, {
                    title: '扫描件操作',
                    dataIndex: 'id',
                    width: '110px',
                    render: (text, record, index) => {
                        // 状态0:待处理,1:未上传,2:已上传,3:财务已确认,4:财务已驳回
                        let btns = '';
                        switch (record.status) {
                            case 1:
                                if (record.signMethod == 0) {
                                    btns = (
                                        <span className="table-btns">
                                        {
                                            button_limits_end.rebateBill_upload &&
                                            <a onClick={() => this.operating('upload', record)}>上传</a>
                                        }
                                    </span>
                                    )
                                }
                                break;
                            case 2:
                                btns = (
                                    <span className="table-btns">
                                        {
                                            (button_limits_end.rebateBill_download && record.signMethod == 0) &&
                                            <span>
                                                <a onClick={() => this.operating('download', record)}>下载</a>
                                            </span>
                                        }
                                        {
                                            (button_limits_end.rebateBill_download && record.signMethod == 1) &&
                                            <span>
                                                <a onClick={() => this.operating('downLoadEsign', record)}>下载</a>
                                            </span>
                                        }
                                        {
                                            (button_limits_end.rebateBill_fileLook && record.signMethod == 0) &&
                                            <span>
                                                <a onClick={() => this.operating('lookFile', record)}>查看</a>
                                            </span>
                                        }
                                        {
                                            (button_limits_end.rebateBill_fileLook && record.signMethod == 1) &&
                                            <span>
                                                <a onClick={() => this.operating('lookEsign', record)}>查看</a>
                                            </span>
                                        }
                                        {
                                            (button_limits_end.rebateBill_turnDown && record.signMethod == 0) &&
                                            <a onClick={() => this.operating('turnDown', record)}>驳回</a>
                                        }
                                    </span>
                                )
                                break;
                            case 3:
                                btns = (
                                    <span className="table-btns">
                                        {
                                            (button_limits_end.rebateBill_download && record.signMethod == 0) &&
                                            <span>
                                                <a onClick={() => this.operating('download', record)}>下载</a>
                                            </span>
                                        }
                                        {
                                            (button_limits_end.rebateBill_download && record.signMethod == 1) &&
                                            <span>
                                                <a onClick={() => this.operating('downLoadEsign', record)}>下载</a>
                                            </span>
                                        }
                                        {
                                            (button_limits_end.rebateBill_fileLook && record.signMethod == 0) &&
                                            <span>
                                                <a onClick={() => this.operating('lookFile', record)}>查看</a>
                                            </span>
                                        }
                                        {
                                            (button_limits_end.rebateBill_fileLook && record.signMethod == 1) &&
                                            <span>
                                                <a onClick={() => this.operating('lookEsign', record)}>查看</a>
                                            </span>
                                        }
                                    </span>
                                )
                                break;
                            case 4:
                                btns = (
                                    <span className="table-btns">
                                        {
                                            (button_limits_end.rebateBill_upload && record.signMethod == 0) &&
                                            <a onClick={() => this.operating('upload', record)}>上传</a>
                                        }
                                    </span>
                                )
                                break;
                            case 6:
                                btns = (
                                    <span className="table-btns">
                                        {
                                            (button_limits_end.rebateBill_download && record.signMethod == 1) &&
                                            <span>
                                                <a onClick={() => this.operating('downLoadEsign', record)}>下载</a>
                                            </span>
                                        }
                                        {
                                            (button_limits_end.rebateBill_fileLook && record.signMethod == 1) &&
                                            <span>
                                                <a onClick={() => this.operating('lookEsign', record)}>查看</a>
                                            </span>
                                        }
                                        {
                                            (button_limits_end.rebateBill_fileLook && record.signMethod == 1) &&
                                            <span>
                                                <a onClick={() => {
                                                    window.open(url + "/login?service=" + url + "/contractdetail/" + record.eSignNo + "?mobile=" + record.eSignPhone + "&loginType=pin");
                                                }}>签署</a>
                                            </span>
                                        }
                                    </span>
                                )
                                break;
                        }
                        return btns;
                    },
                },
                {
                    title: '记账状态',
                    dataIndex: 'id2',
                    width: '80px',
                    render: (text, record, index) => {
                        // 状态0:待处理,1:未上传,2:已上传,3:财务已确认,4:财务已驳回
                        let btns = '';
                        switch (record.status) {
                            case 2:
                                btns = (
                                    <span className="table-btns">
                                        {
                                            button_limits_end.rebateBill_confirm &&
                                            <a onClick={() => this.operating('confirm', record)}>确认</a>
                                        }
                                    </span>
                                )
                                break;
                        }
                        return btns;
                    },
                },
                {
                    title: '财务回复',
                    dataIndex: 'financialReturn',
                },
                {
                    title: '发送状态',
                    dataIndex: 'id3',
                    width: '80px',
                    render: (text, record, index) => {
                        // 状态0:待处理,1:未上传,2:已上传,3:财务已确认,4:财务已驳回
                        let btns = '';
                        switch (record.status) {
                            case 0:
                                btns = (
                                    <span className="table-btns">
                                        {
                                            button_limits_end.rebateBill_send &&
                                            <a onClick={() => this.operating('send', record)}>发送</a>
                                        }
                                        {
                                            button_limits_end.rebateBill_send &&
                                            <a onClick={() => this.operating('sendEsign', record)}>自动发送</a>
                                        }
                                    </span>
                                )
                                break;
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                            case 6:
                                btns = (
                                    <span className="table-btns">
                                        {
                                            button_limits_end.rebateBill_back &&
                                            <a onClick={() => this.operating('back', record)}>撤回</a>
                                        }
                                    </span>
                                )
                                break;
                        }
                        return btns;
                    },
                },

            ],
            rows,
        };

        const myUploadProps = {
            // maxWidth: 360,
            // maxHeight: 235,
            value: fileList,
            maxSize: 1,
            maxCount: 1,
            onChange: list => this.uploadChange(list),
            antdUploadProps: {
                accept: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar,.png,.jpg,.jpeg,.pdf',
                // listType: 'picture',
                showUploadList: {showRemoveIcon: true, showPreviewIcon: false},
            },
        };
        const uploadButton = (
            <div>
                <Button key="submit" type="primary" size="large">上传</Button>
            </div>
        );

        const {pdfFile, numPages} = this.state;
        return <div className="dms-body">
            <DmsTab options={['返利单']} defaultKey={0}>
                {/*<Button icon="plus" onClick={this.operating.bind(this, `/carousel/add/0`)}>新增</Button>*/}
            </DmsTab>

            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    {
                        // 不根据客户判断，配置权限控制
                        button_limits_end.rebateBill_query &&
                        <AdvanceFormNew {...advanceProps} />
                    }
                </div>
            </div>
            <div className="dms-table-box">
                <Row className="mb-12" type="flex" justify="end" align="middle">
                    <Button type="primary" onClick={this.exportData.bind(this)}>导出</Button>&nbsp;&nbsp;
                    {
                        button_limits_end.rebateBill_sendAll &&
                        <Button type="primary" onClick={this.oneSendAll.bind(this)}>一键发送</Button>
                    }
                    &nbsp;&nbsp;
                    {
                        button_limits_end.rebateBill_batchDownload &&
                        <Button type="primary" onClick={this.batchDownload.bind(this)}>批量下载附件</Button>
                    }
                    &nbsp;&nbsp;
                    {
                        // button_limits_end.rebateBill_oneImport &&
                        // <Button type="primary" onClick={this.oneImport.bind(this)}>一键导入返利</Button>
                    }
                </Row>
                <TableView {...tableViewProps} />
            </div>

            <Modal title="批量下载扫描件" visible={this.state.oneImportVisible} closable={false}
                   footer={[
                       <Button key="back" type="ghost" size="large" disabled={this.state.visitLoading}
                               onClick={this.modalCancel.bind(this, 'oneImportVisible')}>取消</Button>,
                       <Button key="submit" type="primary" size="large" loading={this.state.visitLoading}
                               onClick={this.oneImportOk.bind(this)}>确定</Button>,
                   ]}
            >
                <Row type="flex" justify="space-around">
                    <Col span={18}>
                        <span style={{color: 'red'}}>*</span>确认时间：
                        <RangePicker style={{width: 280}}
                                     format="YYYY-MM-DD"
                                     placeholder={['开始时间', '结束时间']}
                                     onChange={this.onImportDateChange.bind(this)}
                                     value={this.state.importParams.dateValue}
                        />
                    </Col>
                    <Col span={18}>
                        <span style={{color: 'red'}}>&nbsp;</span>客户名称：
                        <Input onChange={this.onImportCustChange.bind(this)} value={this.state.importParams.custName}
                               style={{width: 280, marginTop: '10px'}}></Input>
                    </Col>
                    <Col span={18}>
                        <span style={{color: 'red'}}>&nbsp;</span>购货单位：
                        <Input onChange={this.onImportUnitChange.bind(this)} value={this.state.importParams.salesUnit}
                               style={{width: 280, marginTop: '10px'}}></Input>
                    </Col>
                    <Col span={18}>
                        <span style={{color: 'red'}}>&nbsp;</span>审批者：
                        <Input onChange={this.onImportConfirmChange.bind(this)}
                               value={this.state.importParams.confirmPeople}
                               style={{width: 280, marginTop: '10px'}}></Input>
                    </Col>
                </Row>
                {/* <Row type="flex" justify="space-around" style={{ marginTop: 15 }}>
                    <Col span={18} >
                        &nbsp;流程编号：<Input style={{ width: 200 }} placeholder="请输入流程编号"
                            onChange={this.onImportCodeChange.bind(this)} value={this.state.importParams.fbillno} />
                    </Col>
                </Row> */}
            </Modal>

            <Modal title="查看详情" visible={this.state.rebateBillDetailVisible} width="1200px"
                   wrapClassName="vertical-center-modal" closable={false}
                   footer={[
                       <Button key="submit" type="primary" size="large" disabled={this.state.visitLoading}
                               onClick={this.exportDetail.bind(this)}>导出</Button>,
                       <Button key="back" type="ghost" size="large" disabled={this.state.visitLoading}
                               onClick={this.modalCancel.bind(this, 'rebateBillDetailVisible')}>关闭</Button>,
                       // <Button key="submit" type="primary" size="large" loading={this.state.visitLoading}
                       //     onClick={this.rebateBillDetailOk.bind(this)}>确定</Button>,
                   ]}
            >
                <div className="bill-details">
                    <table cellPadding={0} cellSpacing={0}>
                        <tbody>
                        <tr className="title">
                            {
                                // 标题
                                this.state.billDetailTitle.map((item) => {
                                    return <td>{item}</td>
                                })
                            }
                        </tr>
                        {
                            (() => {
                                let rows = [];
                                // 内容
                                this.state.billDetailData.map((item) => {
                                    let row = []
                                    // Object.keys(item).map((name) => {
                                    //     row.push(<td>{item[name]}</td>)
                                    // })
                                    this.state.billDetailTitle.map((key) => {
                                        row.push(<td>{item[key]}</td>)
                                    })
                                    rows.push(<tr className="value">{row}</tr>);
                                })
                                return rows;
                            })()
                        }
                        </tbody>
                    </table>
                </div>
            </Modal>

            {this.state.printBillConfirmVisible && (
                <AntDraggableModal title="打印预览" visible={this.state.printBillConfirmVisible} width="750"
                                   closable={false}
                                   footer={[
                                       <Button key="back" type="ghost" size="large"
                                               onClick={this.modalCancel.bind(this, 'printBillConfirmVisible')}>取消</Button>,
                                       <Button key="submit" type="primary" size="large"
                                               onClick={this.printBillConfirmOk.bind(this)}>
                                           打印
                                       </Button>,
                                   ]}
                >
                    <div className="print" id="printDiv">
                        <div className="print-title">折扣结算确认函</div>
                        <p>
                            尊敬的&nbsp;&nbsp;{selectData.salesUnitName}
                        </p>
                        <p className="print-content">
                            结算日期为<span className="p-bold">{selectData.creationDate}</span>
                            {/*，<span className="p-bold">{selectData.salesChannel}</span>渠道*/}
                            ，单号为<span
                            className="p-bold">{selectData.calculation}</span>，折扣类型为<span
                            className="p-bold">{selectData.discountType}</span>，本次结算金额为<span
                            className="p-bold">￥{selectData.amount}</span>元；计算过程请查看渠道云折扣结算单明细。
                        </p>
                        <p className="print-name">单位确认（盖章）：</p>
                    </div>
                </AntDraggableModal>
            )}

            {
                this.state.lookFileVisible && (
                    <AntDraggableModal title="查看附件" visible={this.state.lookFileVisible} width="750" closable={false}
                                       wrapClassName="vertical-center-modal"
                                       footer={[
                                           <Button key="back" type="ghost" size="large"
                                                   onClick={this.modalCancel.bind(this, 'lookFileVisible')}>关闭</Button>,
                                       ]}
                    >
                        {
                            (extensions.includes(selectData.extension) && selectData.extension != 'pdf') &&
                            <div style={{height: '500px', overflow: 'auto'}} id="preview-div">
                                <img id="preview-img" src={config.server + this.state.selectData.url}
                                     style={{width: '100%'}} onClick={this.handleRote.bind(this)}
                                     onWheel={this.handleWheelImage.bind(this)}/>
                            </div>
                        }
                        {
                            selectData.extension == 'pdf' &&
                            <div style={{height: '500px', overflow: 'auto'}} id="preview-div">
                                {/* <input type="file" onChange={this.onFileChange} /> */}
                                <PDFDocument
                                    file={pdfFile}
                                    loading={<div>正在努力加载中...</div>}
                                    onLoadSuccess={this.onDocumentLoadSuccess.bind(this)}
                                    onLoadError={(e) => {
                                        console.log(e)
                                    }} //加载失败时调用
                                    error={(e) => {
                                        console.log(e)
                                    }}
                                    onClick={this.handleRote.bind(this)}
                                >
                                    {/* <PDFPage pageNumber={numPages} />  */}
                                    {
                                        Array.from(
                                            new Array(numPages),
                                            (el, index) => (
                                                <PDFPage
                                                    key={`page_${index + 1}`}
                                                    pageNumber={index + 1}
                                                />
                                            ),
                                        )
                                    }
                                </PDFDocument>
                            </div>
                        }
                    </AntDraggableModal>
                )
            }

            <Modal title={this.state.operatingBtn == 'confirm' ? '财务确认' : '财务驳回'}
                   visible={this.state.confirmRejectVisible} closable={false}
                   onOk={this.confirmRejectOk.bind(this)} onCancel={this.modalCancel.bind(this, 'confirmRejectVisible')}
            >
                <Row type="flex" justify="center">
                    <Col span={6}>财务回复</Col>
                    <Col span={18}>
                        <Input type="textarea" value={this.state.confirmRejectVal} rows={4} style={{resize: 'none'}}
                               onChange={(e) => {
                                   this.changeConfRejVal(e)
                               }} placeholder="请输入审核意见"/>
                    </Col>
                </Row>
            </Modal>

            <Modal title={this.state.operatingBtn == 'upload' ? '扫描件上传' : '扫描件下载'}
                   visible={this.state.fileUpDownloadVisible} closable={false}
                   footer={[
                       <Button key="back" type="ghost" size="large"
                               onClick={this.modalCancel.bind(this, 'fileUpDownloadVisible')}>取消</Button>,
                       <Button key="submit" type="primary" size="large" onClick={this.fileUpDownloadOk.bind(this)}>
                           {this.state.operatingBtn == 'upload' ? '确定' : '下载'}
                       </Button>,
                   ]}
            >
                {
                    this.state.operatingBtn == 'upload' &&
                    <div>
                        <p>请上传加盖公章的确认文件（扫描件）</p>
                        <MyUpload {...myUploadProps}>
                            {uploadButton}
                        </MyUpload>
                    </div>
                }
                {
                    this.state.operatingBtn == 'download' &&
                    <div>
                        {selectData.confirmTime ? selectData.confirmTime.replace(/-/g, "").replace(/ /g, "").replace(/:/g, "") : ''}
                        {selectData.transferNumber}.pdf
                    </div>
                }
            </Modal>
        </div>;
    }
}

export default withRouter(InfoList);



// WEBPACK FOOTER //
// ./src/routes/rebateBillManage/list.js